import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DocumentRequestInterface } from 'src/app/+home/+document-request/models/document-request.model';
import { endpoints } from '../common/api-endpoints';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentRequestService extends DataService<DocumentRequestInterface> {
  public documentRequestValidated$;
  private _documentRequestValidatedSubject$ = new Subject<any>();

  constructor(httpClient: HttpClient) {
    super(endpoints.documentRequest, httpClient);
    this.documentRequestValidated$ = this._documentRequestValidatedSubject$.asObservable();
  }

  /*
   * data should be the uploaded node from Alfresco
   * */
  uploadFile(documentRequestId, documentId, data: { data: any ,status:string}) {
    return this.http.put(endpoints.documentRequest + `${documentRequestId}/${documentId}`, data);
  }
  sendMessage(documentRequestId,message){
    return this.http.post(endpoints.documentRequest+`${documentRequestId}/relance`,{message});
  }
  clearFile(documentRequestId, documentId) {
    return this.http.put(endpoints.documentRequest + `${documentRequestId}/${documentId}`, { data: {},status:'pending' });
  }
  validateDocumentRequest(documentRequestId) {
    return this.http.put(endpoints.documentRequest + `${documentRequestId}/validate`, {}).pipe(
      tap(res => this._documentRequestValidatedSubject$.next(res)));
  }
  closeDocumentRequest(documentRequestId) {
    return this.http.put(endpoints.documentRequest + `${documentRequestId}/close`, {});
  }
  invalidateDocumentRequest(documentRequestId, reason) {
    return this.http.put(endpoints.documentRequest + `${documentRequestId}/invalidate`, { reason }).toPromise();
  }
  getCreatedDocumentRequests() {
    return this.http.get<any[]>(endpoints.documentRequest + `created`);
  }
  getReceivedDocumentRequests() {
    return this.http.get<any[]>(endpoints.documentRequest + `received`);
  }
  getDocuementRequestById(id:string) {
    return this.http.get<any[]>(endpoints.documentRequest + `${id}`);
  }
  queryDocumentRequests(query) {
    return this.http.post<any[]>(endpoints.documentRequest + `query`, query);
  }
}
